module.exports = __webpack_public_path__ + "static/media/components.97f3a1b3.pdf";